<template>
  <div class="inline-block">
    <HoverTooltip
      class="flex"
      :shift="shift"
      :position="position"
      @click:tooltip="onTooltipClick()"
    >
      <template v-slot:subject>
        <slot></slot>
      </template>

      <template v-slot:tooltip>
        <TooltipContent :text="tooltipText" :icon="tooltipIcon" />
      </template>
    </HoverTooltip>

    <HelpModal :show="showModal" @close="showModal = false" />
  </div>
</template>

<script>
import { HoverTooltip } from '@sportsrecruits/playbook';
import TooltipContent from "./TooltipContent";
import HelpModal from "./HelpModal";
import identifyPage from "@/utils/identifyPage";
import isPaidUser from "@/utils/isPaidUser";
import track from "@/utils/segment";
import trackVerificationCta from "@/utils/trackVerificationCta";

export default {
  components: {
    TooltipContent,
    HoverTooltip,
    HelpModal,
  },

  props: {
    size: { type: String, default: "base" },
    shift: { type: String },
    position: { type: String },
    tooltipText: { type: String, required: true },
    tooltipIcon: { type: String, required: true },
  },

  data() {
    return { showModal: false };
  },

  computed: {
    sizeInPixels() {
      return {
        sm: 10,
        base: 12,
        lg: 14,
        xl: 16,
        "2xl": 20,
        "4xl": 48,
      }[this.size];
    },
  },

  methods: {
    onTooltipClick() {
      trackVerificationCta("not_verified_icon");

      this.showModal = true;
    },
  },
};
</script>